/**
 * @file: 整理货架数据，使货架cube聚合，排在最前面，处理老数据
 * @author: xiaolong.huang@dmall.com
 */

export default function moveShelfToFront(shelfData: JsonData): void {
    let insertIndex: number = 0;

    for(let i: number = 0; i < shelfData.cubes.length; i++) {
        if (shelfData.cubes[i].moduleName === 'shelves' && insertIndex !== i) {
            let temp: FreeObjMap = shelfData.cubes.splice(i, 1)[0];

            shelfData.cubes.splice(insertIndex, 0, temp);
            insertIndex++;
        }

        if (shelfData.cubes[i].moduleName === 'shelves' && insertIndex === i) {
            insertIndex++;
        }
    }
}
